import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({
  root: {
    margin: '-20px 0px 0',
    borderRadius: 3,
    padding: 15,
    float: 'left',
  },
  bigAvatar: {
    position:'absolute',
    left:10,
    top:-40,
    margin: 10,
    width: 80,
    height: 80,
    marginRight:50,
  },
  avatar: {
    margin: '0px'
  },
  blue: {
    background: theme.palette.blue.main,
  },
  orange: {
    background: theme.palette.orange.main,
  },
  green: {
    background: theme.palette.green.main,
  },
  purple: {
    background: theme.palette.purple.main,
  },
  red: {
    background: theme.palette.red.main,
  },

  primary: { background: theme.palette.blue.main },
  second: { background: theme.palette.orange.main },
  success: { background: theme.palette.green.main },
  warning: { background: theme.palette.purple.main },
  error: { background: theme.palette.red.main },
}));
